import ActionTypes from "../../enums/ActionTypes"
import { createAPIRequestReducer } from "../api"

export default createAPIRequestReducer(ActionTypes.BASEDATA_TEMPLATE_DETAILS_LIST)
